// extracted by mini-css-extract-plugin
export default {"wrapExtraInfo":"G4bf7b7","extraInfo":"G9c59d3"};